var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getServiceSchemas from '../../requests/service/getServiceSchemas';
/**
 *
 */
var GetServiceSchemasCommand = /** @class */ (function (_super) {
    __extends(GetServiceSchemasCommand, _super);
    function GetServiceSchemasCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param user User
     * @param serviceSchemaCollection ServiceSchemaCollection
     * @return {*}
     */
    GetServiceSchemasCommand.prototype.execute = function (user, serviceSchemaCollection) {
        this.serviceSchemaCollection = serviceSchemaCollection;
        var promise = getServiceSchemas(user.organisation);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    GetServiceSchemasCommand.prototype.then = function (response) {
        this.serviceSchemaCollection.reset();
        this.serviceSchemaCollection.addAll(response);
    };
    return GetServiceSchemasCommand;
}(Command));
export default GetServiceSchemasCommand;
